module.exports = __webpack_public_path__ + "img/HQ-PA2W1CL_ALL.6b962d16.jpg";